{
  "register": "สมัครสมาชิก",
  "login": "เข้าสู่ระบบ",
  "label": {
    "phoneNumber": "หมายเลขโทรศัพท์",
    "password": "รหัสผ่าน",
    "loginPassword": "รหัสผ่านเข้าสู่ระบบ",
    "confirmLoginPassword": "ยืนยันรหัสผ่านเข้าสู่ระบบ",
    "verificationCode": "รหัสยืนยันทาง SMS",
    "newPassword": "รหัสผ่านใหม่",
    "confirmNewPassword": "ยืนยันรหัสผ่านใหม่",
    "txPassword": "รหัสผ่านสำหรับการทำรายการ"
  },
  "placeholder": {
    "phoneNumber": "กรอกหมายเลขโทรศัพท์",
    "password": "กรอกรหัสผ่าน",
    "loginPassword": "กรอกรหัสผ่านเข้าสู่ระบบ",
    "confirmLoginPassword": "กรอกรหัสผ่านเข้าสู่ระบบอีกครั้ง",
    "verificationCode": "กรอกรหัสยืนยัน",
    "newPassword": "กรอกรหัสผ่านใหม่",
    "confirmNewPassword": "กรอกรหัสผ่านใหม่อีกครั้ง"
  },
  "hint": {
    "password": "อย่างน้อย 8 อักขระ และต้องมีตัวเลขกับตัวอักษรภาษาอังกฤษ",
    "mismatch": "รหัสผ่านทั้งสองไม่ตรงกัน โปรดลองอีกครั้ง",
    "phoneNumberInvalid": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    "repeatedRegister": "หมายเลขโทรศัพท์นี้ถูกใช้แล้ว โปรดลองอีกครั้ง",
    "wrongPassword": "รหัสผ่านไม่ถูกต้อง",
    "passwordInvalid": "ใช้ได้เฉพาะตัวอักษร ตัวเลข และเครื่องหมายวรรคตอนทั่วไป"
  },
  "toast": {
    "success": {
      "changeLoginPassword": "เปลี่ยนรหัสผ่านเข้าสู่ระบบสำเร็จ",
      "sendVerificationCode": "ส่งรหัสยืนยันแล้ว"
    },
    "error": {
      "loginFailed": "หมายเลขโทรศัพท์หรือรหัสผ่านไม่ถูกต้อง",
      "loginRateLimited": "พยายามเข้าสู่ระบบมากเกินไป โปรดลองอีกครั้งใน 15 นาที",
      "otpFailed": "รหัสยืนยันไม่ถูกต้อง โปรดกรอกใหม่หรือขอรหัสใหม่",
      "otpVerificationRateLimited": "พยายามยืนยันรหัสมากเกินไป โปรดลองอีกครั้งใน 15 นาที",
      "sendVerificationCode": "ส่งรหัสยืนยันไม่สำเร็จ",
      "sendVerificationCodeTooFast": "ขอรหัสยืนยันเร็วเกินไป โปรดลองอีกครั้งใน 60 วินาที",
      "sendVerificationCodeQuotaReached": "จำนวนครั้งที่ขอรหัสยืนยันถึงขีดจำกัดแล้ว โปรดลองอีกครั้งใน 15 นาที",
      "smsServiceUnavailable": "บริการ SMS ไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้งภายหลัง",
      "notRegisteredPhoneNumber": "หมายเลขโทรศัพท์นี้ยังไม่ได้ลงทะเบียน",
      "serverError": "เกิดข้อผิดพลาดของเซิร์ฟเวอร์ โปรดลองอีกครั้งภายหลัง",
      "networkError": "เกิดข้อผิดพลาดของเครือข่าย โปรดลองอีกครั้งภายหลัง",
      "timeoutError": "การดำเนินการหมดเวลา โปรดลองอีกครั้ง",
      "changeLoginPasswordFailed": "เปลี่ยนรหัสผ่านเข้าสู่ระบบไม่สำเร็จ โปรดลองอีกครั้ง",
      "invalidOperation": "ไม่สามารถดำเนินการนี้ได้ โปรดรีเฟรชแล้วลองอีกครั้ง",
      "invalidOperationHint": "ไม่สามารถดำเนินการนี้ได้",
      "noAccess": "IP นี้ไม่ได้รับอนุญาต"
    }
  },
  "country": {
    "China": "จีน",
    "Taiwan": "ไต้หวัน",
    "Hong Kong": "ฮ่องกง",
    "Thailand": "ไทย",
    "United States": "สหรัฐอเมริกา",
    "Russia": "รัสเซีย",
    "Netherlands": "เนเธอร์แลนด์",
    "France": "ฝรั่งเศส",
    "Cyprus": "ไซปรัส",
    "United Kingdom": "สหราชอาณาจักร",
    "Poland": "โปแลนด์",
    "Malaysia": "มาเลเซีย",
    "Australia": "ออสเตรเลีย",
    "Indonesia": "อินโดนีเซีย",
    "Philippines": "ฟิลิปปินส์",
    "Singapore": "สิงคโปร์",
    "Japan": "ญี่ปุ่น",
    "Korea": "เกาหลี",
    "Macao": "มาเก๊า",
    "Cambodia": "กัมพูชา",
    "Turkey": "ตุรกี",
    "Myanmar": "เมียนมา",
    "United Arab Emirates": "สหรัฐอาหรับเอมิเรตส์",
    "Israel": "อิสราเอล"
  },
  "countryOrRegion": "ประเทศ/ภูมิภาค",
  "forgetPassword": "ลืมรหัสผ่าน?",
  "clearPhoneNumber": "ล้างหมายเลขโทรศัพท์",
  "otpDeliveryNotice": "SMS อาจล่าช้าเล็กน้อย โปรดใช้ข้อความล่าสุดที่ได้รับ",
  "noAccount": "ยังไม่มีบัญชี? <0>สมัครสมาชิก</0>",
  "haveAccount": "มีบัญชีอยู่แล้ว? <0>เข้าสู่ระบบ</0>",
  "getVerificationCode": "รับรหัสยืนยัน",
  "retryAfterSeconds": "{{count}} วินาที",
  "loginExpired": "เซสชันเข้าสู่ระบบหมดอายุ",
  "continue": "ดำเนินการต่อ",
  "complete": "เสร็จสิ้น",
  "confirm": "ยืนยัน",
  "registerSuccess": "สมัครสมาชิกสำเร็จ",
  "retrievePassword": "กู้คืนรหัสผ่าน",
  "changeLoginPassword": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  "safetyVerification": "การยืนยันความปลอดภัย"
}
